import { iframeHost } from './iframeHost';
import { PixelField } from './PixelField';
import type { ProviderSpec } from './providers';
import type { TrackingFieldName, TrackingFormErrors, TrackingPixelsForm } from './trackingPixelsForm';

type Props = {
  spec: ProviderSpec;
  form: TrackingPixelsForm;
  errors: TrackingFormErrors;
  onChange: (field: TrackingFieldName, value: string) => void;
};

export function ProviderCard({ spec, form, errors, onChange }: Props) {
  return (
    <section className="rounded-xl border border-[var(--co-border)] bg-[var(--co-surface)] p-4">
      <h2 className="text-[14px] font-semibold text-[var(--co-text)]">{spec.title}</h2>
      <p className="mb-2 text-[12px] text-[var(--co-muted)]">{spec.hint}</p>
      <details className="mb-3 text-[12px] text-[var(--co-muted)]">
        <summary className="cursor-pointer font-medium text-[var(--co-text)]">How to set it up</summary>
        <ol className="mt-2 list-decimal space-y-1 pl-5">
          {spec.steps(iframeHost()).map((step) => (
            <li key={step}>{step}</li>
          ))}
        </ol>
      </details>
      <div className="flex flex-col gap-3">
        {spec.fields.map((field) => (
          <PixelField
            key={field.name}
            spec={field}
            value={form[field.name]}
            error={errors[field.name]}
            onChange={(value) => onChange(field.name, value)}
          />
        ))}
      </div>
    </section>
  );
}
